import { ComposerIfVoted, Voting, YourPosition } from 'open-modules/srg/feature/question/dialogue';
import { CLICK, componentWithVariants, demoFile, story, variant } from 'system/demo';
import { t } from 'util/stdtypes';

demoFile('open-modules/srg/feature/question/dialogue');

const baseState = {
    personaKey: 'user1',
    collections: { vote: [] },
};

componentWithVariants('Voting', Voting, { state: baseState }, [
    variant('Default'),
    variant('Vote yes', {}, [story('Select yes', [CLICK('Yes')])]),
]);

componentWithVariants('ComposerIfVoted', ComposerIfVoted, { state: baseState }, [
    variant('No vote'),
    variant('Has vote', {
        state: { collections: { vote: [{ key: 'v1', from: 'user1', value: { label: t('Yes') } }] } },
    }),
]);

componentWithVariants(
    'YourPosition',
    YourPosition,
    {
        args: { comment: { from: 'user2' } },
        state: baseState,
    },
    [
        variant('No vote'),
        variant('Has vote', {
            state: { collections: { vote: [{ key: 'c1', from: 'user2', value: { label: t('Yes') } }] } },
        }),
    ],
);
